import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { useAppSelector } from '../../../store/hooks';
/**
 * Hent custom hjelpetekst for en tjeneste
 * @param tjenesteNavn Navn på tjenesten
 */
const useCustomHjelpetekst = (tjenesteNavn) => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const customHjelpetekst = useAppSelector(state => state.prosesshjelp.customHjelpetekster[`${tjenesteNavn}.${language}`]);
    return {
        hjelpeskuffTittel: customHjelpetekst?.hjelpeskuffTittel,
        hjelpeskuffTekst: customHjelpetekst?.hjelpeskuffTekst,
    };
};
export default useCustomHjelpetekst;
